import React from "react";
import PostalEntry from "../PostalEntry/PostalEntry";
import useTickets from "../../hooks/useTickets";
import SubscriptionCard from "../SubscriptionCard/SubscriptionCard";

import "./styles.css";

const SubscriptionList = (props) => {
  const {
    prizeId,
    raffles,
    isExpired,
    subscriptionModels,
    theme = "light",
  } = props;
  const {
    loading,
    activeSubscription,
    addSubscriptionToBasket,
  } = useTickets({prizeId, isDouble: raffles.length > 1});

  return (
    <div className="ticket-container">
      <div className="ticket-list ticket-list--subscription">
        <>
          {subscriptionModels && subscriptionModels.length
            ? subscriptionModels.map((sub, index) => {
                return (
                  <SubscriptionCard
                    key={index}
                    type={"win"}
                    raffles={raffles}
                    loading={loading}
                    sub={sub}
                    pricePerMonth={`£${sub.totalCost / 100}`}
                    ticket={{ tickets: sub.numOfTickets + sub.extra }}
                    theme={theme}
                    activeSubscription={activeSubscription}
                    isExpired={isExpired}
                    addSub={addSubscriptionToBasket}
                  />
                );
              })
            : null}
          <PostalEntry
            loading={loading}
            theme={raffles.length > 1 ? "light" : theme}
            size={subscriptionModels && subscriptionModels.length >3 ? "lg" : ""}
          />
        </>
      </div>
    </div>
  );
};

export default SubscriptionList;
